import Vue from 'vue';
import Component from 'vue-class-component';

import AuthenticationService from '../../services/AuthenticationService';
import APIService from '../../services/APIService';

/**
 * Handles the response from the oidc authorization server.
 */
@Component({
  name: 'CallbackView',
})
export default class CallbackView extends Vue {
  /**
   * Handles the redirect call.
   */
  private async mounted(): Promise<void> {
    await AuthenticationService.signinRedirectCallback();
    if (!this.$store.state.user) {
      const user = await APIService.getMyUser();
      this.$store.commit('setUser', {
        id: user.id,
        username: user.username,
        roles: user.roles,
        employeeId: user.employeeId,
      });
    }
    this.$router.push('/');
  }
}
